import updateBus from "../bus/updateBus";

export default function getSocketPlugin(socket){
    return  (store) => {
        socket.on('data', (data, received) => {
            for(const list of Object.keys(data.lists)){
                data.lists[list] = data.lists[list].map(entityId=>data.entities[entityId]);
            }
            store.commit('simulationData', data);
            store.commit('refreshTime');
                received();
        });
        socket.on('logout', async (received) => {
            console.log('received logout');
            await store.dispatch('logout');
            received();
        });

        socket.on('update', async (event) => {
            updateBus.$emit('update', event);
        });
        const initialization = async () => {
            if(!store.state.online){
                store.commit('online');
                await store.dispatch('checkToken');
            }
        };
        const offlineHandler = () => {
            if(store.state.online){
                store.commit('offline');
            }
        };
        socket.on('reconnect', initialization);
        socket.on('connect', initialization);
        socket.on('disconnect', offlineHandler);
        socket.on('error', offlineHandler);
        socket.on('reconnecting', offlineHandler);
        socket.on('connect_error', ()=>{
            console.error('socket unavailable');
        });
    }
}
